import { TDropdownItem } from '@treezor/design-system';

import { IWallet } from '@/features/wallets/store/models/wallet.model';
import { TWalletOperation } from '@/features/wallets/store/models/walletOperation.model';
import { IConfirmationDialogReturn } from '@/hooks/useConfirmationModal';
import { TCountryCode } from '@/features/user/store/user.model';

export interface IWalletOperationActionsProps {
  operation: TWalletOperation;
}

export interface IOperationSimulationModalProps {
  wallet: IWallet;
  onClose: () => void;
}

export interface IOperationSimulationForm {
  month: number;
  year: number;
  payin: number;
  payinrefund: number;
  payout: number;
  payoutrefund: number;
  transfer: number;
  cardtransaction: number;
}

export interface ISctrSimulationForm {
  amount: number;
}

export interface IUseWalletMenu {
  walletActions: TDropdownItem[];
  WalletDeactivationDialog: IConfirmationDialogReturn;
  isLoading: boolean;
  isDisabled?: boolean;
}

export const DashboardConfigSettingsWalletsOptions = {
  DETAILS: 'details',
  EDIT: 'edit',
  ACCOUNTDETAILS: 'accountDetails',
  STATEMENT: 'statement',
  DEACTIVATE: 'deactivate',
  SIMULATESCTR: 'simulateSCTR',
  SIMULATEOPERATION: 'simulateOperation',
  BALANCECERTIFICATE: 'balanceCertificate',
  CLOSURECERTIFICATE: 'closureCertificate',
  DOMICILIATIONCERTIFICATE: 'domiciliationCertificate',
} as const;

export const allDadshboardOptions = Object.values(DashboardConfigSettingsWalletsOptions);

export type TDashboardConfigSettingsWalletsOptions =
  (typeof DashboardConfigSettingsWalletsOptions)[keyof typeof DashboardConfigSettingsWalletsOptions];

export interface IDashboardConfigSettingsWallets {
  types: IDashboardConfigSettingsWalletsType[];
  options?: TDashboardConfigSettingsWalletsOptions[];
  localIban?: ILocalIban[];
}

interface ILocalIban {
  distribCountry: TCountryCode;
  bic: TCountryCode[];
}

export interface IDashboardConfigSettingsWalletsType {
  label: string;
  value: number;
}

export interface IDateRangeFilter {
  dateFrom?: Date;
  dateTo?: Date;
}
export interface IAmountRangeFilter {
  amountRange?: {
    minimum?: number;
    maximum?: number;
  };
}

export type TCommonFilters = IDateRangeFilter &
  IAmountRangeFilter & {
    type?: string;
  };
